import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./assets/css/a.bootstrap.min.css";
import "./assets/css/b.magnific-popup.css";
import "./assets/css/c.fe-icon.css";
import "./assets/css/c.fontawesome.min.css";
import "./assets/css/d.nice-select.css";
import "./assets/css/e.meanmenu.css";
import "./assets/css/f.default.css";
import "./assets/css/main.css";
import "./assets/css/style.css";
import "./assets/css/t.responsive.css";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
